/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TModalLoadExcelService = {
  payload: {
    orderId: number;
    controlaLucratividade: boolean;
    tabelaPreco: string;
		fkVigencia: string;
    file: File;
    jsonData: Record<string, any>;
  };
};

export const modalLoadExcelService = async ({
  payload,
}: TModalLoadExcelService): Promise<ResponseAPI> => {
  const fileBase64 = await readFileAsBase64(payload.file)

  const fileBase64WithoutPrefix = fileBase64.replace(
    /^data:application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet;base64,/,
    '',
  )
  const response = await api.post(
    `importarplanilha/${payload.orderId}/${payload.tabelaPreco}/${payload.fkVigencia}/${payload.controlaLucratividade}`,
    {
      file: fileBase64WithoutPrefix,
      json: payload.jsonData,
    },
    {
      maxBodyLength: Number.POSITIVE_INFINITY,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return response.data
}

const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result)
      } else {
        reject(new Error('Falha ao ler o arquivo como base64.'))
      }
    }
    reader.onerror = () => {
      reject(reader.error)
    }
    reader.readAsDataURL(file)
  })
}
